import axios from 'CanExConfig/axios'

export const fetchProfileCompletion = async id => {
  const response = await axios.get(`/api/candidate/profiles/${id}/incomplete_sections`)
  return response.data
}
